export const enum QueryKeys {
  EventValueRangesForDevice = 'eventValueRangesForDevice',
  EventValueRangesForDeviceSensor = 'eventValueRangesForDeviceSensor',
  SpecificEventValueRange = 'specificEventValueRange',
  AddValueRange = 'addValueRange',
  UpdateValueRange = 'updateValueRange',
  UpdateValueRangePriority = 'updateValueRangePriority',
  DeleteValueRange = 'deleteValueRange',
  CopyValueRanges = 'copyValueRanges',
  DevicePortsConfig = 'devicePortsConfig',
  GetDashboards = 'getDashboards',
  GetDashboard = 'getDashboard',
  CreateDashboard = 'createDashboard',
  UpdateDashboard = 'updateDashboard',
  DeleteDashboard = 'deleteDashboard',
  SetDefaultDashboard = 'setDefaultDashboard',
  SetFavoriteDashboard = 'setFavoriteDashboard',
  UpdateDashboardLayout = 'updateDashboardLayout',
  GetWidgets = 'getWidgets',
  GetWidget = 'getWidget',
  CreateWidget = 'createWidget',
  UpdateWidget = 'updateWidget',
  DeleteWidget = 'deleteWidget',
  GetDataSources = 'getDataSources',
  GetDataSource = 'getDataSource',
  CreateDataSource = 'createDataSource',
  UpdateDataSource = 'updateDataSource',
  DeleteDataSource = 'deleteDataSource',
  GetVariableSources = 'getVariableSources',
  GetVariableSource = 'getVariableSource',
  CreateVariableSource = 'createVariableSource',
  UpdateVariableSource = 'updateVariableSource',
  DeleteVariableSource = 'deleteVariableSource',
  GetVariables = 'getVariables',
  GetVariable = 'getVariable',
  CreateVariable = 'createVariable',
  UpdateVariable = 'updateVariable',
  DeleteVariable = 'deleteVariable',
  DeviceInitialConfig = 'deviceInitialConfig',
  UpdateDeviceInitialConfig = 'updateDeviceInitialConfig',
  GetDevicesPortsConfigsBatch = 'getDevicesPortsConfigsBatch',
  GetConsumptionExport = 'getConsumptionExport',
  MultipleReadingsExport = 'multipleReadingsExport',
  UseDeviceData = 'useDeviceData',
  GetDeviceConfig = 'getDeviceConfig',
  GetDevicesConfigsBatch = 'getDevicesConfigsBatch',
  CopyDeviceConfig = 'copyDeviceConfig',
  GetUtilityRates = 'getUtilityRates',
  GetUtilityRate = 'getUtilityRate',
  CreateUtilityRate = 'createUtilityRate',
  UpdateUtilityRate = 'updateUtilityRate',
  DeleteUtilityRate = 'deleteUtilityRate',
  GeneralStatistics = 'generalStatistics',
  FlowStatistics = 'flowStatistics',
  QFlowStatistics = 'qFlowStatistics',
  TimeHistogramStatistics = 'timeHistogramStatistics',
  GetAllCompanies = 'getAllCompanies',
  GetCompaniesForDevice = 'getCompaniesForDevice',
  CreateDeviceFromTemplate = 'createDeviceFromTemplate',
  UseDeviceLocationData = 'useDeviceLocationData',
  UseUpdateDeviceLocationData = 'useUpdateDeviceLocationData',
  UseDeviceLocationsHistory = 'useDeviceLocationsHistory',
  GetConsumptionBillingReport = 'getConsumptionBillingReport',
  GetDeviceGroupsByCompanyId = 'getDeviceGroupsByCompanyId',
  GetAutoDeviceGroupTypes = 'getAutoDeviceGroupTypes',
  GetDeviceGroupsFromParent = 'getDeviceGroupsFromParent',
  CreateDeviceGroup = 'createDeviceGroup',
  UpdateDeviceGroup = 'updateDeviceGroup',
  DeleteDeviceGroup = 'deleteDeviceGroup',
  AddDeviceSensorToGroup = 'addDeviceSensorToGroup',
  DeleteDeviceAndSensorFromGroup = 'deleteDeviceAndSensorFromGroup',
  GetDeviceGroupPercentageBreakdown = 'getDeviceGroupPercentageBreakdown',
  GetAlarmsExport = 'getAlarmsExport',
  GetActiveAlarmsForCompany = 'getActiveAlarmsForCompany',
  GetNumberOfActiveAlarms = 'getNumberOfActiveAlarms',
  UseDeviceNodeLinks = 'useDeviceNodeLinks',
  UseDeviceNodeLink = 'useDeviceNodeLink',
  CreateDeviceNodeLink = 'CreateDeviceNodeLink',
  DeleteAllDeviceNodeLinks = 'DeleteAllDeviceNodeLinks',
  UseDeviceNodeSensorLinks = 'UseDeviceNodeSensorLinks',
  DeleteDeviceNodeSensorLinks = 'DeleteDeviceNodeSensorLinks',
  GetSignalStatus = 'getSignalStatus',
  GetDevicesSignal = 'getDevicesSignal',
  GetDeviceBattery = 'getDeviceBattery',
  GetBatteryStatus = 'getBatteryStatus',
  UseRelayStatus = 'useRelayStatus',
  UseRelayStatuses = 'useRelayStatuses',
  GetDevicesFlow = 'getDevicesFlow',
  GetDevicesFlowAvg = 'getDeviceFlowAvg',
  GetDeviceSensorReadings = 'getDeviceSensorReadings',
  GetDeviceReadings = 'getDeviceReadings',
  GetDevicesReadingsAvg = 'getDevicesReadingsAvg',
  GetCurrentReadings = 'getCurrentReadings',
  FetchDevicesReadings = 'fetchDevicesReadings',
  GetTimeSeriesPrediction = 'getTimeSeriesPrediction',
  GetDevicesIcons = 'getDevicesIcons',
  UpdateDeviceIcon = 'updateDeviceIcon',
  CreateDevice = 'createDevice',
  UpdateDevice = 'updateDevice',
  DeleteDevice = 'deleteDevice',
  BatchAddValueRanges = 'batchAddValueRanges',
  getTransmissions = 'getTransmissions',
  GetFeatureFlags = 'getFeatureFlags',
  getDashboard = 'getDashboard',
  UpdateSettings = 'updateSettings',
  GetDeviceGroupFlow = 'getDeviceGroupFlow',
  GetDeviceGroupFlowAggregated = 'getDeviceGroupFlowAggregated',
  GetDeviceGroupFlowAverageAggregated = 'getDeviceGroupFlowAverageAggregated',
  GetDeviceGroupStatistics = 'getDeviceGroupStatistics',
  GetDeviceGroupStatisticsTotal = 'getDeviceGroupStatisticsTotal',
  SensorTypeConfig = 'sensorTypeConfig',
  GetMap = 'getMap',
  UpdateMap = 'updateMap',
  GetUser = 'getUser',
  GetUsers = 'getUsers',
  UpdateUser = 'updateUser',
  CreateUser = 'createUser',
  DeleteUser = 'deleteUser',
  ResetPassword = 'resetPassword',
  GenerateApiToken = 'generateApiToken',
  GetIcons = 'getIcons',
  GetMapPins = 'getMapPins',
  CreateIcon = 'createIcon',
  UpdateIcon = 'updateIcon',
  GetCompanyInfo = 'getCompanyInfo',
  UpdateCompanyInfo = 'updateCompanyInfo',
  DeleteCompanyInfo = 'deleteCompanyInfo',
  GetClientCount = 'getClientCount',
  GetScheduledEventTaskExecutions = 'getScheduledEventTaskExecutions',
  GetScheduledEventBasedOnScheduledEventId = 'getScheduledEventBasedOnScheduledEventId',
  GetSensorAllowedUnits = 'getSensorAllowedUnits',
  GetLicenses = 'getLicenses',
  CreateLicense = 'createLicense',
  GetLicense = 'getLicense',
  ChangeLicenseActivity = 'changeLicenseActivity',
  CreateCompany = 'createCompany',
  DeleteCompany = 'deleteCompany',
  UpdateCompany = 'updateCompany',
  GetAllScheduledEventsInCompany = 'getAllScheduledEventsInCompany',
  GetScheduledEventsLogsForEvent = 'getScheduledEventsLogsForEvent',
  PatchScheduledEvent = 'patchScheduledEvent',
  DeleteScheduledEvent = 'deleteScheduledEvent',
  GetSpecificScheduledEventById = 'getSpecificScheduledEventById',
  GetDeviceLimits = 'getDeviceLimits',
  LinkDevice = 'linkDevice',
  UnlinkDevice = 'unlinkDevice',
  GetCustomerBillingReport = 'getCustomerBillingReport',
  GetTimezones = 'getTimezones',
  ValidateFormula = 'validateFormula',
  GetCountries = 'getCountries',
  GetCompany = 'getCompany',
  GetVersionInfo = 'getVersionInfo',
  GetDeviceModels = 'getDeviceModels',
  CreateDeviceCommand = 'createDeviceCommand',
  GetDeviceCommands = 'getDeviceCommands',
  GetCommandTypes = 'getCommandTypes',
  GetCommandTypeParameters = 'getCommandTypeParameters',
  UpdateDeviceCommand = 'updateDeviceCommand',
  PollLinkedDevices = 'pollLinkedDevices',
  GetGeneratedReportsForCompanyBetweenDates = 'getGeneratedReportsForCompanyBetweenDates',
  GetAllReportConfigsForCompany = 'getAllReportConfigsForCompany',
  CreateReportConfig = 'createReportConfig',
  UpdateReportConfig = 'updateReportConfig',
  DeleteReportConfig = 'deleteReportConfig',
  GetReportConfigFromReportName = 'getReportConfigFromReportName',
  GetTrashbagsBatch = 'getTrashbagsBatch',
  GetTrashbagsBatchById = 'getTrashbagsBatchById',
  GetTrashbagsAccountNumbers = 'getTrashbagsAccountNumbers',
  GetTrashbagsCollections = 'getTrashbagsCollections',
  GetTruckCollectionAggregation = 'getTruckCollectionAggregation',
  GetTruckCollection = 'getTruckCollection',
  GetContainerCollection = 'getContainerCollection',
  GetTrucks = 'getTrucks',
  GetContainers = 'getContainers',
}
